<div class="button-wrap" *ngIf="!viewConfigurations.showFilterNavigationMenu">
  <span class="btn small outline-light" [class.selected]="pageType === pageTypeEnum.Soon"
    (click)="selectMostPopularOrNextMatches(false)"
    i18n="Sport tree select last minute events@@SportTreeLastMinuteEvents">Naredni mečevi</span>
  <span class="btn small outline-light" [class.selected]="pageType === pageTypeEnum.MostPopular"
    (click)="selectMostPopularOrNextMatches(true)"
    i18n="Sport tree select most played events@@SportTreeMostPlayedEvents">Najigraniji parovi</span>
</div>

<section class="sport-tree" [class.versionV2]="viewConfigurations.useMobileViewWithTopMenu">
  <ng-container *ngIf="!isMobileView; else mobileView">
    <div class="section-title" *ngIf="viewConfigurations.showSportTitle">Sport</div>
    <ul class="list">
      <li>
        <div *ngIf="viewConfigurations.isFavoriteSportTreeElementsEnabled && favoriteCompetitions.length > 0 && favoriteCompetitionsHaveOnlineEvents" class="sport-info" [class.open]="favoriteLeaguesIsExpanded" (click)="toggleFavoriteCompetitions()">
          <div class="name-wrap list-title">
            <!-- <div class="icon-wrap"> -->
              <!-- <app-svg-icon iconId="star"></app-svg-icon> -->
              <i class="icon-width sporticon icon-sm sporticon-star m-r"></i>
            <!-- </div> -->
            <span class="name h5">{{dynamicTranslations.favoriteButtonName}}</span>
          </div>
        </div>
        <ul class="sub-list region-list" *ngIf="favoriteLeaguesIsExpanded && favoriteCompetitions.length > 0">
          <ng-container *ngFor="let competition of favoriteCompetitions; trackBy: identify">
            <li [class.selected]="competition.isSelected" *ngIf="competition.isShown"
              (click)="selectCompetitionFromFavorites(competition)">
              <div class="name-wrap flex">
                <div class="region-name-wrap list-title">
                  <span class="icon icon-width" (click)="addRemoveCompetitionToFavorites(competition); $event.stopPropagation();">
                    <!-- <app-svg-icon iconId="{{competition.isInFavorites ? 'star' : 'star-empty'}}"></app-svg-icon> -->
                    <span class="sporticon icon-sm sporticon-{{competition.isInFavorites  ? 'star' : 'star-border'}}"></span>
                  </span>
                  <span class="region-name">{{competition.regionName}} {{competition.name}}</span>
                </div>
              </div>
              <span class="events-name">{{competition.eventsCount}}</span>
            </li>
          </ng-container>
        </ul>
      </li>
      <ng-container *ngFor="let sport of sports; let i = index; trackBy: identify">
        <li *ngIf="sport.eventsCount > 0">
          <div class="sport-info" [class.open]="sport.isSelected && sport.showRegions" (click)="selectSport(sport, $event);">
            <div class="name-wrap list-title">
              <i class="icon-width sporticon icon-sm m-r sporticon-all" *ngIf="sport.id == -1"><sub>{{dynamicTranslations.specialOfferEventsShorcutEventOfDay}}</sub></i>
              <i class="icon-width sporticon icon-sm m-r sporticon-all" *ngIf="sport.id == -2"><sub>{{dynamicTranslations.specialOfferEventsShorcutSuperBet}}</sub></i>
              <i class="icon-width sporticon icon-sm m-r sporticon-all" *ngIf="sport.id == -3"><sub>{{dynamicTranslations.specialOfferEventsShorcutOutrights}}</sub></i>
              <i class="icon-sm m-r s-icon-{{getSportName(sport.id)}} sportid-{{sport.id}}" *ngIf="sport.id > 0"></i>
              <!-- <div class="icon-wrap">
                  <app-svg-icon iconId="{{sport.id}}"></app-svg-icon>
              </div> -->
              <span class="name h5">{{sport.name}}</span>
            </div>
            <div class="events-number">{{sport.eventsCount}}</div>
          </div>

          <ul class="sub-list region-list" *ngIf="sport.isSelected && sport.showRegions">
            <ng-container *ngFor="let region of sport.regions; trackBy: identify">
              <li *ngIf="region.eventsCount > 0" [class.selected]="region.isSelected" (click)="selectRegion(region, sport)">
                <div class="name-wrap flex">
                  <div class="region-name-wrap list-title">
                    <span class="region-flag-wrap">
                      <span class="region-flag reg-{{regionNameMap.getRegionName(region.id)}} region-{{region.id}}"></span>
                      <!-- <span class="region-flag reg-{{region.id}}"></span> -->
                      <!-- <span class="region-flag reg-{{regionNameMap.getRegionName(region.id)}}"></span> -->
                    </span>
                    <span class="region-name">{{region.name}}</span>
                  </div>
                  <span class="events-name">{{region.eventsCount}}</span>

                </div>
              </li>
              <ul class="sub-list region-list" *ngIf="viewConfigurations.showCompetitionsInSportTree && region.showCompetitions">
                <ng-container *ngFor="let competition of region.competitions">
                  <li *ngIf="competition.eventsCount>0" (click)="selectCompetition(competition, sport,region)" [class.selected]="competition.isSelected">
                    <div class="name-wrap flex">
                      <div class="region-name-wrap list-title">
                        <span *ngIf="viewConfigurations.isFavoriteSportTreeElementsEnabled" class="icon"
                          (click)="addRemoveCompetitionToFavorites(competition); $event.stopPropagation();">
                          <!-- <app-svg-icon iconId="{{competition.isInFavorites ? 'star' : 'star-empty'}}"></app-svg-icon> -->
                          <span class="sporticon icon-sm sporticon-{{competition.isInFavorites  ? 'star' : 'star-border'}}"></span>
                        </span>
                        <span class="region-name">{{competition.name}}</span>
                      </div>
                      <span class="events-name">{{competition.eventsCount}}</span>
                    </div>
                  </li>
                </ng-container>
              </ul>
            </ng-container>
          </ul>

        </li>

      </ng-container>
    </ul>
  </ng-container>

  <ng-template #mobileView>
    <app-filter></app-filter>
    <app-sports-tree-breadcrumbs *ngIf="srcSelection && srcSelection.sport; else sportTitle"
      [sport]="srcSelection.sport" [region]="srcSelection.region" [competition]="srcSelection.competition">
    </app-sports-tree-breadcrumbs>
    <ng-template #sportTitle>
      <div class="section-title" *ngIf="!srcSelection || !srcSelection.sport;">Sport</div>
    </ng-template>

    <ul class="list">
      <ng-container *ngFor="let sport of sports; trackBy: identify">
        <ng-container *ngIf="!srcSelection || !srcSelection.sport; else selectedSportDiv">
          <li *ngIf="sport.eventsCount > 0">
            <div class="sport-info" [class.open]="sport.isSelected"
              (click)="selectSport(sport, null, sport.specialOfferType? true : false);">
              <div class="name-wrap">
                <i class="sporticon icon-sm m-r sporticon-all" *ngIf="sport.id == -1"><sub>{{dynamicTranslations.specialOfferEventsShorcutEventOfDay}}</sub></i>
                <i class="sporticon icon-sm m-r sporticon-all" *ngIf="sport.id == -2"><sub>{{dynamicTranslations.specialOfferEventsShorcutSuperBet}}</sub></i>
                <i class="sporticon icon-sm m-r sporticon-all" *ngIf="sport.id == -3"><sub>{{dynamicTranslations.specialOfferEventsShorcutOutrights}}</sub></i>
                <i class="icon-sm m-r s-icon-{{getSportName(sport.id)}} sportid-{{sport.id}}" *ngIf="sport.id > 0"></i>
                <span class="name h5">{{sport.name}}</span>
              </div>
              <div class="events-number">{{sport.eventsCount}}</div>
            </div>
          </li>
        </ng-container>
        <ng-template #selectedSportDiv>
          <ng-container *ngIf='srcSelection.sport.id === sport.id && sport.id > 0'>
            <ng-container *ngFor="let region of sport.regions; trackBy: identify">
              <li *ngIf="region.eventsCount > 0">
                <div class="sport-info" [class.open]="region.isSelected" (click)="selectRegion(region, sport)">
                  <div class="name-wrap">
                    <span class="region-flag-wrap">
                      <span class="region-flag reg-{{regionNameMap.getRegionName(region.id)}} region-{{region.id}}"></span>
                      <!-- <span class="region-flag reg-{{region.id}}"></span> -->
                    </span>
                    <span class="name">{{region.name}}</span>
                  </div>
                  <div class="events-number">{{region.eventsCount}}</div>
                </div>
              </li>
            </ng-container>
          </ng-container>
        </ng-template>
      </ng-container>
    </ul>

    <div class="no-result"
      *ngIf="(sports.length === 0 || (showNoEventsForSportMessage && srcSelectionIds.sId)) && !initialLoad">
      <span i18n="there are no data for the selected filter@@EmptyFilterResult">Nema ponude za odabrani filter</span>
    </div>
  </ng-template>





  <!-- <div class="show-more">Show more</div> -->
  <div class="stat-res-wrap" *ngIf="viewConfigurations.showStatisticsInTree">
    <!-- <a href="https://s5dev.sir.sportradar.com/admiralbeteeuof" class="btn darkgray" target="_blank">Statistika</a>
      <a href="https://lsdev.sir.sportradar.com/admiralbeteeuof" class="btn darkgray" target="_blank">Rezultati</a> -->

    <a href="https://s5.sir.sportradar.com/{{betRadarCompanyName}}/{{languageForBetradar}}"
      onclick="window.open(this.href, 'newwindow', 'width=1210, height=700'); return false;"
      onkeypress="window.open(this.href, 'newwindow', 'width=1210, height=700'); return false;" class="btn dark-blue"
      i18n="Sport Tree Statistics Button@@SportTreeStatistics">Statistika</a>
    <a id="liveResultButton" href="https://ls.sir.sportradar.com/{{betRadarCompanyName}}/{{languageForBetradar}}"
      onclick="window.open(this.href, 'newwindow', 'width=1210, height=700'); return false;"
      onkeypress="window.open(this.href, 'newwindow', 'width=1210, height=700'); return false;" class="btn dark-blue"
      i18n="Sport Tree Livescore Button@@SportTreeLivescore">Rezultati</a>
  </div>

  <ul class="list" *ngIf="oddSheets && viewConfigurations.showOddSheets">
    <li *ngIf="oddSheets.mainList">
      <div class="sport-info" (click)="downloadList(oddSheets.mainList.fileName, true)">
        <div class="name-wrap">
          <i></i>
          <span class="name h5"><span i18n="Sport Tree MainList name@@SportTreeMainListName">Lista broj</span>
            <b> {{oddSheets.mainList.name}}</b></span>
        </div>
        <div i18n="Sport Tree list download link@@SportTreeListDownload">preuzmi</div>
      </div>
    </li>
    <li *ngIf="oddSheets.dailyLists && oddSheets.dailyLists.oddSheets.length > 0">
      <div class="sport-info" (click)="oddSheets.dailyLists.isSelected = !oddSheets.dailyLists.isSelected">
        <div class="name-wrap">
          <i></i>
          <span class="name h5">
            <span i18n="Sport Tree SubList name no plural@@SportTreeSubListNameNoPlural">Daily oddsheets for</span>
            {{oddSheets.dailyLists.dateString}}
          </span>
        </div>
        <div class="events-number">{{oddSheets.dailyLists.oddSheetsCount}}</div>
      </div>
    </li>
    <ng-container *ngIf="oddSheets.dailyLists && oddSheets.dailyLists.isSelected">
      <ng-container *ngFor="let dailyList of oddSheets.dailyLists.oddSheets;">
        <li>
          <div class="sport-info" (click)="downloadList(dailyList.fileName, false)">
            <div class="name-wrap">
              <span class="name">{{dailyList.name}}</span>
            </div>
            <div i18n="Sport Tree list download link@@SportTreeListDownload">preuzmi</div>
          </div>
        </li>
      </ng-container>
    </ng-container>
  </ul>
</section>
